import cn from "classnames";
import { checkIsNumber } from "helpers";
import { useEffect, useState } from "react";
import { Range, getTrackBackground } from "react-range";
import { Input } from "ui/Input";

import { LineInputRangeProps } from "./LineInputRange.types";

import styles from "./LineInputRange.module.scss";

const LineInputRange = ({
  values,
  min,
  max,
  onChange,
  withInputs = false,
  disabled = false
}: LineInputRangeProps) => {
  const [currentValues, setCurrentValues] = useState<number[]>(values);

  useEffect(() => {
    setCurrentValues(values);
  }, [min, max, values]);

  const changeValues = (newValues: number[]) => {
    if (disabled) return;
    setCurrentValues(newValues);
    onChange(newValues);
  };

  const setFirstValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    const value = e.target.value;
    if (!checkIsNumber(value)) return;

    const numberValue = Number(value);
    if (numberValue >= max) changeValues([max, currentValues[1]]);
    else changeValues([numberValue, currentValues[1]]);
  };
  const setSecondValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!checkIsNumber(value)) return;

    const numberValue = Number(value);
    if (numberValue <= min) changeValues([currentValues[0], min]);
    else if (numberValue >= max) changeValues([currentValues[0], max]);
    else changeValues([currentValues[0], numberValue]);
  };

  return (
    <div className={cn(disabled && styles.wrapper_disabled)}>
      <div
        className={cn(
          styles.rangeInput,
          disabled && styles.rangeInput_disabled
        )}
      >
        <div className={styles.rangeInput_valuesContainer}>
          {withInputs ? (
            <>
              <Input value={currentValues[0]} onChange={setFirstValue} />
              <p>-</p>
              <Input value={currentValues[1]} onChange={setSecondValue} />
            </>
          ) : (
            <>
              <p>{currentValues[0]}</p>
              <p>{currentValues[1]}</p>
            </>
          )}
        </div>

        <Range
          values={currentValues}
          step={1}
          min={min}
          max={max}
          allowOverlap
          onChange={(nextValues) => {
            setCurrentValues(nextValues);
          }}
          onFinalChange={onChange}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                paddingBottom: 14
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: 4,
                  width: "100%",
                  borderRadius: 10,
                  background: getTrackBackground({
                    values: currentValues,
                    colors: ["#EAEAEF", "#fb3973", "#EAEAEF"],
                    min,
                    max
                  }),
                  alignSelf: "center"
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props, isDragged: _isDragged }) => (
            <div
              {...props}
              key={props.key}
              style={{
                ...props.style,
                height: 22,
                width: 22,
                borderRadius: "50%",
                backgroundColor: "#FFF",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 2px 6px #AAA"
              }}
            />
          )}
        />
      </div>
    </div>
  );
};

export default LineInputRange;
